<app-header></app-header>

<div class="page-title-area page-title-style-two item-rights">
    <div class="container">
        <div class="page-title-content">
            <ul>
                <li><a routerLink="/">Home</a></li>
                <li>Conducere si acces CMTAMP</li>
            </ul>
            <h2>Conducere si acces CMTAMP</h2>
        </div>
    </div>
</div>

<div class="about-area ptb-100">
    <div class="container">
        <div class="row">
            <div class="col-12">
                <h3> Conducere CMDTAMP</h3>
                <p>
                    Director General Radulescu Serban
                </p>
                <p> Diretor Medical Negreanu Ana Maria </p>
                <p> Director Economic Bulugu Danut </p>
                <p> Director Administrativ Anghel Alexandru  </p>
                <p> Director Tehnic Cristescu Ioan</p>
                <p>Telefon: <a href="tel:0212302980">0212302980</a></p>
                <p>Mail: <a href="mailto:secretariat@cmdtamp.ro">secretariat@cmdtamp.ro</a></p>

                <h3>Program Audiente</h3>
                <p>
                    Director General			luni 	10:00 - 12:00
                </p>
                <p> Director Medical			marti 	11:00 - 13:00 </p>


                <h3>Program cu publicul - zilnic de Luni pana Vineri</h3>
                <p> Programari 07:00 – 21:00</p>
                <p> Mail: <a href="mailto:programari@cmdtamp.ro">programari@cmdtamp.ro</a></p>
                <p> Evidenta pacienti 07:00 – 21:00</p>
                <p> Mail:  <a href="mailto:evidenta@cmdtamp.ro">evidenta@cmdtamp.ro</a></p>
                <p> Cabinete Medicale 07:00 – 21:00</p>
                <p> Mail:  <a href="mailto:office@cmdtamp.ro">office@cmdtamp.ro</a></p>
                <p> Secretariat 08:00 – 14:00 </p>
                <p>>Mail:  <a href="mailto:secretariat@cmdtamp.ro">secretariat@cmdtamp.ro</a></p>

                <h3>Relalatii publice si Purtator de cuvant</h3>
                <p>Telefon: <a href="tel:0212302980">0212302980/342</a></p>
                <p>Mail: <a href="mailto:relatii.publice@cmdtamp.ro">relatii.publice@cmdtamp.ro/342</a></p>

            </div>
        </div>
    </div>
</div>
